var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-state"},[_c('span',{staticClass:"empty-state__text"},[_vm._v(_vm._s(_vm.$t("message.facebook.noConnectedFacebookAccount")))])])}
var staticRenderFns = []

export { render, staticRenderFns }